import { render, staticRenderFns } from "./OriginSelection.vue?vue&type=template&id=5e8f1f8c&"
import script from "./OriginSelection.vue?vue&type=script&lang=js&"
export * from "./OriginSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports